import { Map, List, fromJS } from 'immutable'
import { combineActions, handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'

// constants
export const FETCH_SITE_LIST = 'monitorsAndAlerts/FETCH_SITE_LIST'
export const SUCCESS_SITE_LIST = 'monitorsAndAlerts/SUCCESS_SITE_LIST'
export const FAILURE_SITE_LIST = 'monitorsAndAlerts/FAILURE_SITE_LIST'

export const FETCH_LOCUS_LIST = 'monitorsAndAlerts/FETCH_LOCUS_LIST'
export const SUCCESS_LOCUS_LIST = 'monitorsAndAlerts/SUCCESS_LOCUS_LIST'
export const FAILURE_LOCUS_LIST = 'monitorsAndAlerts/FAILURE_LOCUS_LIST'

export const FETCH_FILTERS = 'monitorsAndAlerts/FETCH_FILTERS'
export const SUCCESS_FILTERS = 'monitorsAndAlerts/SUCCESS_FILTERS'
export const FAILURE_FILTERS = 'monitorsAndAlerts/FAILURE_FILTERS'

export const FETCH_DATA = 'monitorsAndAlerts/FETCH_DATA'
export const SUCCESS_DATA = 'monitorsAndAlerts/SUCCESS_DATA'
export const FAILURE_DATA = 'monitorsAndAlerts/FAILURE_DATA'

export const SET_LICENSEE_LIST_LOADER =
  'monitorsAndAlerts/SET_LICENSEE_LIST_LOADER'
export const SET_SITE_LIST_LOADER = 'monitorsAndAlerts/SET_SITE_LIST_LOADER'
export const SET_LOCUS_LIST_LOADER = 'monitorsAndAlerts/SET_LOCUS_LIST_LOADER'
export const SET_SUMMARY_LOADER = 'monitorsAndAlerts/SET_SUMMARY_LOADER'
export const SET_TABLE_LOADER = 'monitorsAndAlerts/SET_TABLE_LOADER'

export const FETCH_CRITERIA_LIST = 'monitorsAndAlerts/FETCH_CRITERIA_LIST'
export const SUCCESS_CRITERIA_LIST = 'monitorsAndAlerts/SUCCESS_CRITERIA_LIST'
export const FAILURE_CRITERIA_LIST = 'monitorsAndAlerts/FAILURE_CRITERIA_LIST'

export const FETCH_INDICATORS_LIST = 'monitorsAndAlerts/FETCH_INDICATORS_LIST'
export const SUCCESS_INDICATORS_LIST =
  'monitorsAndAlerts/SUCCESS_INDICATORS_LIST'
export const FAILURE_INDICATORS_LIST =
  'monitorsAndAlerts/FAILURE_INDICATORS_LIST'

export const FETCH_POLICY_EDITOR_DATA =
  'monitorAndAlerts/FETCH_POLICY_EDITOR_DATA'
export const SUCCESS_POLICY_EDITOR_DATA =
  'monitorAndAlerts/SUCCESS_POLICY_EDITOR_DATA'
export const FAILURE_POLICY_EDITOR_DATA =
  'monitorAndAlerts/FAILURE_POLICY_EDITOR_DATA'

export const UPDATE_NOTIFICATION_SUBSCRIBERS =
  'monitorAndAlerts/UPDATE_NOTIFICATION_SUBSCRIBERS'
export const [
  UPDATE_NOTIFICATION_SUBSCRIBERS_SUCCESS,
  UPDATE_NOTIFICATION_SUBSCRIBERS_FAILURE,
] = [
  `${UPDATE_NOTIFICATION_SUBSCRIBERS}_SUCCESS`,
  `${UPDATE_NOTIFICATION_SUBSCRIBERS}_FAILURE`,
]

export const FETCH_REGION_LIST = 'monitorsAndAlerts/FETCH_REGION_LIST'
export const [FETCH_REGION_LIST_SUCCESS, FETCH_REGION_LIST_FAILURE] = [
  `${FETCH_REGION_LIST}_SUCCESS`,
  `${FETCH_REGION_LIST}_FAILURE`,
]

export const FETCH_SITE_GROUPS_LIST = 'monitorsAndAlerts/FETCH_SITE_GROUPS_LIST'
export const [
  FETCH_SITE_GROUPS_LIST_SUCCESS,
  FETCH_SITE_GROUPS_LIST_FAILURE,
] = [`${FETCH_SITE_GROUPS_LIST}_SUCCESS`, `${FETCH_SITE_GROUPS_LIST}_FAILURE`]

export const FETCH_SITE_TYPES = 'monitorsAndAlerts/FETCH_SITE_TYPES'
export const [FETCH_SUCCESS_SITE_TYPES, FETCH_FAILURE_SITE_TYPES] = [
  `${FETCH_SITE_TYPES}_SUCCESS`,
  `${FETCH_SITE_TYPES}_FAILURE`,
]

export const FETCH_LOCUS_GROUPS = 'monitorsAndAlerts/FETCH_LOCUS_GROUPS'
export const [FETCH_SUCCESS_LOCUS_GROUPS, FETCH_FAILURE_LOCUS_GROUPS] = [
  `${FETCH_LOCUS_GROUPS}_SUCCESS`,
  `${FETCH_LOCUS_GROUPS}_FAILURE`,
]

export const SET_ACTIVE_LICENSEE = 'monitorsAndAlerts/SET_ACTIVE_LICENSEE'
export const SET_ACTIVE_SITE = 'monitorsAndAlerts/SET_ACTIVE_SITE'
export const SET_ACTIVE_LOCUS = 'monitorsAndAlerts/SET_ACTIVE_LOCUS'
export const SET_ACTIVE_CRITERIA = 'monitorsAndAlerts/SET_ACTIVE_CRITERIA'
export const SET_ACTIVE_INDICATORS = 'monitorsAndAlerts/SET_ACTIVE_INDICATORS'
export const SET_INCLUDE_LEVEL_LOWER =
  'monitorsAndAlerts/SET_INCLUDE_LEVEL_LOWER'
export const SET_INCLUDE_LEVEL_LOWER_CHECKBOX =
  'monitorsAndAlerts/SET_INCLUDE_LEVEL_LOWER_CHECKBOX'
export const CLEAR_STORE = 'monitorsAndAlerts/CLEAR_STORE'
const SET_LOCUS_GROUPS_LOADED = 'monitorsAndAlerts/SET_LOCUS_GROUPS_LOADED'
export const RESET_DATA = 'monitorsAndAlerts/RESET_DATA'
const RESET_SITES_DATA = 'monitorsAndAlerts/RESET_SITES_DATA'

// actions
export const fetchSiteList = ActionHelper.createActionObj(FETCH_SITE_LIST)
export const fetchLocusList = ActionHelper.createActionObj(FETCH_LOCUS_LIST)
export const fetchFilters = ActionHelper.createActionObj(FETCH_FILTERS)
export const fetchData = ActionHelper.createActionObj(FETCH_DATA)
export const fetchCriteriaList = ActionHelper.createActionObj(
  FETCH_CRITERIA_LIST,
)
export const fetchIndicatorList = ActionHelper.createActionObj(
  FETCH_INDICATORS_LIST,
)
export const fetchPolicyEditorList = ActionHelper.createActionObj(
  FETCH_POLICY_EDITOR_DATA,
)
export const fetchRegionList = ActionHelper.createActionObj(FETCH_REGION_LIST)
export const fetchSiteGroupsList = ActionHelper.createActionObj(
  FETCH_SITE_GROUPS_LIST,
)
export const fetchSiteTypes = ActionHelper.createActionObj(FETCH_SITE_TYPES)
export const fetchLocusGroups = ActionHelper.createActionObj(FETCH_LOCUS_GROUPS)

export const setActiveLicensee = ActionHelper.createActionObj(
  SET_ACTIVE_LICENSEE,
)
export const setActiveSite = ActionHelper.createActionObj(SET_ACTIVE_SITE)
export const setActiveLocus = ActionHelper.createActionObj(SET_ACTIVE_LOCUS)
export const setActiveCriteria = ActionHelper.createActionObj(
  SET_ACTIVE_CRITERIA,
)
export const setActiveIndicators = ActionHelper.createActionObj(
  SET_ACTIVE_INDICATORS,
)
export const setIncludeLevelLower = ActionHelper.createActionObj(
  SET_INCLUDE_LEVEL_LOWER,
)
export const setIncludeLevelLowerCheckbox = ActionHelper.createActionObj(
  SET_INCLUDE_LEVEL_LOWER_CHECKBOX,
)
export const setAnyParamsStore = ActionHelper.createActionObj(
  ActionHelper.SET_ANY_PARAMS_STORE,
)
export const updateNotificationSubscribers = ActionHelper.createActionObj(
  UPDATE_NOTIFICATION_SUBSCRIBERS,
)
export const clearMnaStore = ActionHelper.createActionObj(CLEAR_STORE)
export const setLocusGroupsLoaded = ActionHelper.createActionObj(
  SET_LOCUS_GROUPS_LOADED,
)
export const resetData = ActionHelper.createActionObj(RESET_DATA)
export const resetSitesData = ActionHelper.createActionObj(RESET_SITES_DATA)

// store
const initialState = () =>
  fromJS({
    isLoadLicenseeList: false,
    isLoadSiteList: false,
    isLoadLocusList: false,
    isLoadSummary: false,
    isLoadTable: false,
    isLocusGroupsLoaded: false,
    isLoadPolicyEditorTable: false,
    updatingSubscribers: false,
    siteList: [],
    locusList: [],
    filters: [],
    criteriaList: [],
    criteriaLoader: false,
    indicators: [],
    indicatorsLoader: false,
    activeCriteria: [],
    activeIndicators: [],
    activeLicensee: {
      id: 0,
      name: '',
    },
    activeSite: {
      id: 0,
      name: '',
    },
    activeLocus: {
      id: 0,
      containerName: '',
    },
    data: {
      summary: {},
      rows: [],
    },
    policyEditorList: {
      count: null,
      data: [],
    },
    includeLevelLower: false,
    showIncludeLevelLowerCheckbox: true,
    regionList: [],
    siteGroupsList: [],
    siteTypes: [],
    locusGroupList: [],
    dataLoader: false,
  })

const monitorsAndAlerts = handleActions(
  {
    [SUCCESS_SITE_LIST]: (state, action) =>
      state.set('siteList', List(action.payload)),
    [FAILURE_SITE_LIST]: state => state.set('siteList', List([])),

    [SUCCESS_LOCUS_LIST]: (state, action) =>
      state.set('locusList', List(action.payload)),
    [FAILURE_LOCUS_LIST]: state => state.set('locusList', List([])),

    [FETCH_REGION_LIST_SUCCESS]: (state, action) =>
      state.set('regionList', List(action.payload)),
    [FETCH_REGION_LIST_FAILURE]: state => state.set('regionList', List([])),

    [FETCH_SITE_GROUPS_LIST_SUCCESS]: (state, action) =>
      state.set('siteGroupsList', List(action.payload)),
    [FETCH_SITE_GROUPS_LIST_FAILURE]: state =>
      state.set('siteGroupsList', List([])),

    [SUCCESS_FILTERS]: (state, action) =>
      state.set('filters', List(action.payload)),
    [FAILURE_FILTERS]: state => state.set('filters', List([])),

    [SUCCESS_DATA]: (state, action) => state.set('data', Map(action.payload)),
    [FAILURE_DATA]: state =>
      state.set(
        'data',
        Map({
          summary: {},
          rows: [],
        }),
      ),

    [SET_LICENSEE_LIST_LOADER]: (state, action) =>
      state.set('isLoadLicenseeList', Boolean(action.payload)),
    [SET_SITE_LIST_LOADER]: (state, action) =>
      state.set('isLoadSiteList', Boolean(action.payload)),
    [SET_LOCUS_LIST_LOADER]: (state, action) =>
      state.set('isLoadLocusList', Boolean(action.payload)),
    [SET_SUMMARY_LOADER]: (state, action) =>
      state.set('isLoadSummary', Boolean(action.payload)),
    [SET_TABLE_LOADER]: (state, action) =>
      state.set('isLoadTable', Boolean(action.payload)),

    [FETCH_CRITERIA_LIST]: state => state.set('criteriaLoader', true),
    [SET_LOCUS_GROUPS_LOADED]: (state, action) =>
      state.set('isLocusGroupsLoaded', Boolean(action.payload)),
    [SUCCESS_CRITERIA_LIST]: (state, action) =>
      state
        .set('criteriaLoader', false)
        .set('criteriaList', List(action.payload)),
    [FAILURE_CRITERIA_LIST]: state =>
      state
        .set('criteriaLoader', false)
        .set('criteriaList', initialState.get('criteriaList')),
    [SET_ACTIVE_CRITERIA]: (state, action) =>
      state.set('activeCriteria', List(action.payload)),

    [FETCH_INDICATORS_LIST]: state => state.set('indicatorsLoader', true),
    [SUCCESS_INDICATORS_LIST]: (state, action) =>
      state
        .set('indicatorsLoader', false)
        .set('indicators', List(action.payload)),
    [FAILURE_INDICATORS_LIST]: state =>
      state
        .set('indicatorsLoader', false)
        .set('indicators', initialState.get('indicators')),
    [SET_ACTIVE_INDICATORS]: (state, action) =>
      state.set('activeIndicators', List(action.payload)),

    [FETCH_POLICY_EDITOR_DATA]: state =>
      state.set('isLoadPolicyEditorTable', true),
    [SUCCESS_POLICY_EDITOR_DATA]: (state, action) =>
      state
        .set('policyEditorList', Map(action.payload))
        .set('isLoadPolicyEditorTable', false),
    [FAILURE_POLICY_EDITOR_DATA]: state =>
      state
        .set('policyEditorList', initialState().get('policyEditorList'))
        .set('isLoadPolicyEditorTable', false),

    [UPDATE_NOTIFICATION_SUBSCRIBERS]: state =>
      state.set('updatingSubscribers', true),
    [combineActions(
      UPDATE_NOTIFICATION_SUBSCRIBERS_SUCCESS,
      UPDATE_NOTIFICATION_SUBSCRIBERS_FAILURE,
    )]: state => state.set('updatingSubscribers', false),

    [combineActions(
      FETCH_REGION_LIST,
      FETCH_SITE_TYPES,
      FETCH_LOCUS_LIST,
    )]: state => state.set('dataLoader', true),

    [combineActions(
      FETCH_REGION_LIST_SUCCESS,
      FETCH_REGION_LIST_FAILURE,
      FETCH_SUCCESS_SITE_TYPES,
      FETCH_FAILURE_SITE_TYPES,
      SUCCESS_LOCUS_LIST,
      FAILURE_LOCUS_LIST,
    )]: state => state.set('dataLoader', false),

    [SET_ACTIVE_LICENSEE]: (state, action) =>
      state.set('activeLicensee', Map(action.payload)),

    [SET_ACTIVE_SITE]: (state, action) =>
      state.set('activeSite', Map(action.payload)),

    [SET_ACTIVE_LOCUS]: (state, action) =>
      state.set('activeLocus', Map(action.payload)),

    [SET_INCLUDE_LEVEL_LOWER]: (state, action) =>
      state.set('includeLevelLower', Boolean(action.payload)),

    [SET_INCLUDE_LEVEL_LOWER_CHECKBOX]: (state, action) =>
      state.set('showIncludeLevelLowerCheckbox', Boolean(action.payload)),

    [FETCH_SUCCESS_SITE_TYPES]: (state, action) =>
      state.set('siteTypes', List(action.payload)),
    [FETCH_FAILURE_SITE_TYPES]: state => state.set('siteTypes', List([])),

    [FETCH_SUCCESS_LOCUS_GROUPS]: (state, action) =>
      state.set('locusGroupList', List(action.payload)),
    [FETCH_FAILURE_LOCUS_GROUPS]: state =>
      state.set('locusGroupList', List([])),

    [RESET_DATA]: state =>
      state.set('locusList', List([])).set('locusGroupList', List([])),
    [RESET_SITES_DATA]: state =>
      state.set('regionList', List([])).set('siteTypes', List([])),

    [ActionHelper.SET_ANY_PARAMS_STORE]: ActionHelper.setAnyParamsStore,

    [CLEAR_STORE]: () => initialState(),
  },
  initialState(),
)

export default monitorsAndAlerts
